import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { RegistrationResultModel } from 'src/app/models/registration/registration-result.model';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-registration-modal',
    templateUrl: './registration-modal.component.html',
    styleUrl: './registration-modal.component.scss',
    standalone: false
})
export class RegistrationModalComponent {
  @Input() showModal = false;
  @Output() showModalChange = new EventEmitter<boolean>();
  
  @Input() registrationResultModel!: RegistrationResultModel;

  constructor(
    private translateService: TranslateService, 
    private sanitizer: DomSanitizer
  ) {
   
  }

  loginTextHtml!: SafeHtml;
  ngOnInit() {
    this.translateService.get('COMMON.HERE').subscribe(translatedHere => {
      const loginLink = `<a href="/login" class="text-link">${translatedHere}</a>`;

      this.translateService
        .get('REGISTRATION.PLEASE-LOGIN-HERE', {
          login_here: loginLink,
        })
        .subscribe(finalText => {
          this.loginTextHtml = this.sanitizer.bypassSecurityTrustHtml(finalText);
        });
    });
  }

  close() {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  }
}
